export default __webpack_public_path__ + "static/increase-cart-value-970d62a8907c51e45b9bb6ee28ac3c35.svg";